module.exports = __webpack_public_path__ + "img/icon23.e5e05f41.png";